module.exports = __webpack_public_path__ + "a768e7de/img/search-filter-icon.c4751a52.svg";